<script setup lang="ts">
import { getClasses } from '~/js/composables/classes'

interface Props {
    color?: string,
    size?: string,
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    color: 'text-neutral-900',
    size: 'text-base',
    utilities: ''
})

const classes = {
    font: 'font-primary',
}
</script>

<template>
    <span :class="[
        getClasses(classes),
        color,
        size,
        utilities
    ]">
        <slot></slot>
    </span>
</template>